/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Handoveremailwrittenby3Inputs */

const de__field_handoveremailwrittenby3 = /** @type {(inputs: _Field_Handoveremailwrittenby3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergabe-E-Mail geschrieben von`)
};

/**

* @param {_Field_Handoveremailwrittenby3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_handoveremailwrittenby3 = /** @type {((inputs?: _Field_Handoveremailwrittenby3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Handoveremailwrittenby3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_handoveremailwrittenby3(inputs)
});
export { _field_handoveremailwrittenby3 as "_field_handoverEmailWrittenBy" }